
      export const versions = {
        commit: 'd1d3943753329e06bfe3b9adfeda3a2e85bf6bab',
        branch: 'HEAD'
      };
